import {
  deleteWorkOrder,
  getContractWorkOrders,
  storeWorkOrder,
  updateWorkOrder
} from "../../api-helpers/contracts/api-work-orders";

export default {
  state: {
    isGettingContractWorkOrders: false,
    contractWorkOrders: null,
    isStoringWorkOrder: false,
    isUpdatingWorkOrder: false,
    isDeletingWorkOrder: false
  },
  mutations: {
    setIsGettingContractWorkOrders(state, bool) {
      state.isGettingContractWorkOrders = bool;
    },
    setContractWorkOrders(state, workOrders) {
      state.contractWorkOrders = workOrders;
    },
    setIsStoringWorkOrder(state, bool) {
      state.isStoringWorkOrder = bool;
    },
    setIsUpdatingWorkOrder(state, bool) {
      state.isUpdatingWorkOrder = bool;
    },
    setIsDeletingWorkOrder(state, bool) {
      state.isDeletingWorkOrder = bool;
    }
  },
  actions: {
    async getContractWorkOrders({ state, commit }, contractId) {
      let contractWorkOrders = state.contractWorkOrders;
      if (!state.isGettingContractWorkOrders) {
        commit("setIsGettingContractWorkOrders", true);

        contractWorkOrders = await getContractWorkOrders(contractId);
        commit("setContractWorkOrders", contractWorkOrders);

        commit("setIsGettingContractWorkOrders", false);
      }
      return contractWorkOrders;
    },
    async storeWorkOrder({ state, commit, dispatch }, workOrder) {
      let response;
      if (!state.isStoringWorkOrder) {
        commit("setIsStoringWorkOrder", true);

        response = await storeWorkOrder(workOrder);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Work Order stored successfully.",
          errorText: "An error occurred while attempting to store Work Order.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getContractWorkOrders", workOrder.contract_id);
          }
        });

        commit("setIsStoringWorkOrder", false);
      }
      return response;
    },
    async updateWorkOrder({ state, commit, dispatch }, workOrder) {
      let response;
      if (!state.isUpdatingWorkOrder) {
        commit("setIsUpdatingWorkOrder", true);

        response = await updateWorkOrder(workOrder);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Work Order updated successfully.",
          errorText: "An error occurred while attempting to update Work Order.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            if (workOrder.isDashboardView) {
              dispatch("getWorkOrders");
            } else {
              dispatch("getContractWorkOrders", workOrder.contract_id);
            }
          }
        });

        commit("setIsUpdatingWorkOrder", false);
      }
      return response;
    },
    async deleteWorkOrder({ state, commit, dispatch }, workOrder) {
      let response;
      if (!state.isDeletingWorkOrder) {
        commit("setIsDeletingWorkOrder", true);

        response = await deleteWorkOrder(workOrder);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Work Order deleted successfully.",
          errorText: "An error occurred while attempting to delete Work Order.",
          afterSuccessFunction: () => {
            commit("resetConfirmationModalParams");
            if (workOrder.isDashboardView) {
              dispatch("getWorkOrders");
            } else {
              dispatch("getContractWorkOrders", workOrder.contract_id);
            }
          }
        });

        commit("setIsDeletingWorkOrder", false);
      }
      return response;
    }
  }
};
